import { render, staticRenderFns } from "./CreateCampaignGreeting.vue?vue&type=template&id=df52a836&scoped=true"
import script from "./CreateCampaignGreeting.vue?vue&type=script&lang=js"
export * from "./CreateCampaignGreeting.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignGreeting.vue?vue&type=style&index=0&id=df52a836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df52a836",
  null
  
)

export default component.exports